import { RefObject, useEffect } from 'react';

interface UseResizeObserverProps<T> {
  target: RefObject<T> | (() => T | null);
  onChange?: () => void;
}

export function useResizeObserver<T extends Element>({
  target,
  onChange,
}: UseResizeObserverProps<T>) {
  useEffect(() => {
    const targetElement = isRef(target)
      ? (target as RefObject<T>).current
      : (target as Function)();
    if (!targetElement) { return; }
    const observer = new ResizeObserver(() => onChange?.());
    observer.observe(targetElement);
    return () => observer.disconnect();
  }, []);
}

function isRef(obj: Object) {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    Object.prototype.hasOwnProperty.call(obj, 'current')
  );
}
